import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { Button, Input, message, Checkbox, Card, Form, Popconfirm, Select } from 'antd';
import { mutations, queries } from '../../graphql/graphql';

const { Option } = Select;

const UserEdit = props => {
  const { currentUser } = props;
  const { params } = props.match;

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [isVerified, setIsVerified] = useState(false);
  const [role, setRole] = useState('');

  const { loading, data = {} } = useQuery(queries.USER, {
    variables: { id: params.id }
  });

  useEffect(() => {
    if (data && data.user) {
      if (data.user.name) setName(data.user.name);
      if (data.user.email) setEmail(data.user.email);
      if (data.user.isVerified) setIsVerified(data.user.isVerified);
      if (data.user.role) setRole(data.user.role);
    }
  }, [data]);

  const [USER_UPDATE] = useMutation(mutations.USER_UPDATE);
  const [USER_DELETE] = useMutation(mutations.USER_DELETE);

  const saveUser = () => {
    const data = {
      id: params.id,
      name,
      email,
      role,
      isVerified
    };

    USER_UPDATE({ variables: data }).then(
      res => {
        message.success('User updated!');
        props.history.push(`/user/${params.id}`);
      },
      err => {
        console.log(err);
        message.error('Error. Check if all fields are filled.');
      }
    );
  };

  const deleteUser = () => {
    USER_DELETE({ variables: { id: params.id } }).then(
      res => {
        message.success('User deleted');
        props.history.push(`/admin/users`);
      },
      err => {
        console.log(err);
        message.error('Error. Check if all fields are filled.');
      }
    );
  };

  const confirmDelete = () => {
    deleteUser();
  };

  const cancelDelete = () => {
    message.info('Deletion cancelled');
  };

  const onChange = (e, setState) => {
    const { value } = e.target;
    setState(value);
  };

  if (loading) return <div>loading...</div>;

  return (
    <Card
      title="Edit User"
      hoverable
      style={{ minWidth: '350px', width: '50vw', margin: '20px auto' }}
    >
      <Form layout="vertical">
        <Form.Item label="Name">
          <Input name="name" placeholder="Name" onChange={e => onChange(e, setName)} value={name} />
        </Form.Item>
        <Form.Item label="Email">
          <Input
            name="email"
            placeholder="Email"
            onChange={e => onChange(e, setEmail)}
            value={email}
          />
        </Form.Item>
        <Form.Item label="Role">
          <Select
            name="role"
            placeholder="Select a role"
            onChange={value => setRole(value)}
            value={role}
          >
            <Option value="USER">USER</Option>
            <Option value="ADMIN">ADMIN</Option>
          </Select>
        </Form.Item>
        <Form.Item>
          <Checkbox checked={isVerified} onChange={e => setIsVerified(e.target.checked)}>
            Verified
          </Checkbox>
        </Form.Item>
        <Form.Item>
          <Button type="primary" onClick={() => saveUser()}>
            Save
          </Button>
          {currentUser.id !== params.id && (
            <Popconfirm
              title="Are you sure to delete this user?"
              onConfirm={confirmDelete}
              onCancel={cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              <Button type="danger" style={{ marginLeft: '10px' }}>
                Delete
              </Button>
            </Popconfirm>
          )}
        </Form.Item>
      </Form>
    </Card>
  );
};

const mapStateToProps = state => {
  return {
    currentUser: state.auth.user
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

UserEdit.propTypes = {
  currentUser: PropTypes.object.isRequired
};

const connectedEdit = connect(mapStateToProps, mapDispatchToProps)(UserEdit);

export default connectedEdit;
